import React from 'react';
import { Form, Radio, Grid, Popup, Segment, Select } from 'semantic-ui-react';
import { BaseURLDev, headers } from '../../../../../../_utils/config';
import { fetchOPD } from '../../../../../../_utils/localstorage';
import swal from 'sweetalert';

export default class FormAddOPD extends React.Component {
   constructor(props){
      super(props);
      this.state = {
         data:{
               "username": "",
               "password": "",
               "alamat": "",
               "nama": "",
               "jabatan": "",
               "kode": "",
               "contact": "",

               "kd_urusan": "",
               "kd_bidang": "",
               "kd_unit": "",
               "kd_sub": ""
            },

         loading: false,
         error: false,
         opds: [],
         is_manual: true,
         opd_select_temp: null,
         error_username: false,
         error_password: false,
         error_alamat: false,
         error_nama: false,
         error_jabatan: false,
         error_kode: false,
         error_contact: false,
      }

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.getDataOPD = this.getDataOPD.bind(this);
      this.onToggleRadio = this.onToggleRadio.bind(this);
      this.onChangeOPD = this.onChangeOPD.bind(this);
   }

   componentWillMount(){
      
      if(fetchOPD().length===0) this.getDataOPD();
      else this.opdSelect();
      
   }

   onToggleError(username,password,kode,nama,jabatan,contact,alamat){
      this.setState({
         error_username: username,
         error_password: password,
         error_kode: kode,
         error_nama: nama,
         error_jabatan: jabatan,
         error_contact: contact,
         error_alamat: alamat,
      })
   }

   onSubmit(e){
      const { opd_select_temp } = this.state;
      const { password, contact, username, kode, nama, jabatan, alamat, kd_urusan, kd_bidang, kd_unit, kd_sub } = this.state.data;
      this.setState({ loading: true });
      e.preventDefault();
      if(kd_urusan == null || kd_urusan == "" || kd_bidang == null || kd_urusan == "" || kd_unit == null || kd_urusan == "" || kd_sub == null || kd_urusan == ""){
         this.setState({loading: false, error: true});
         // this.onToggleError()
         swal("", "Nama OPD harus dipilih terlebih dahulu", "error")
         return false;
      }else if(opd_select_temp===null || opd_select_temp===""){
         this.setState({loading: false, error: true});
         // this.onToggleError()
         swal("", "Nama OPD harus dipilih terlebih dahulu", "error")
         return false;
      }else if(username===null || username===""){
         this.setState({loading: false, error_password: true, error_username: true});
         this.onToggleError(true,false,false,false,false,false,false)
         swal("", "Username harus diisi", "error")
         return false;
      }else if(password===null || password===""){
         this.setState({loading: false, error_password: true, error_username: true});
         this.onToggleError(false,true,false,false,false,false,false)
         swal("", "Password harus diisi", "error")
         return false;
      }else if(kode===null || kode===""){
         this.setState({loading: false, error_kode: true});
         this.onToggleError(false,false,true,true,true,true,true)
         swal("", "NIP/Kode Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else if(nama===null || nama===""){
         this.setState({loading: false, error_nama: true});
         this.onToggleError(false,false,false,true,true,true,true)
         swal("", "Nama Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else if(jabatan===null || jabatan===""){
         this.setState({loading: false, error_jabatan: true});
         this.onToggleError(false,false,false,false,true,true,true)
         swal("", "Jabatan Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else if(contact===null || contact===""){
         this.setState({loading: false, error_contact: true});
         this.onToggleError(false,false,false,false,false,true,true)
         swal("", "Contact Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else if(alamat===null || alamat===""){
         this.setState({loading: false, error_alamat: true});
         this.onToggleError(false,false,false,false,false,false,true)
         swal("", "Alamat Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else{
         this.setState({ loading: true });
         e.preventDefault();
         fetch(`${BaseURLDev}/users/opd`,{
            method: 'POST',
            headers,
            body: JSON.stringify(this.state.data)
         })
         .then(response => {
            if (!response.ok) { 
                  swal("", "Register user gagal", "error");
                  this.onToggleError()
                  this.setState({loading: false});
                  return Promise.reject(response.statusText);
               }
            // else{
            //    this.setState({
            //       loading: false,
            //       error: false,
            //       data: {
            //          "username": "",
            //          "password": "",
            //          "alamat": "",
            //          "nama": "",
            //          "jabatan": "",
            //          "kode": "",
            //          "contact": "",
            //       }
            //    });
            // }
            return response.json();
         })
         .then(() => {
            swal("", "Register user sukses!", "success");
            this.onToggleError()
            this.setState({
               loading: false,
               data: {
                  "username": "",
                  "password": "",
                  "alamat": "",
                  "nama": "",
                  "jabatan": "",
                  "kode": "",
                  "contact": "",
               }
            });
         })
      }
   }

   onCheckUserExits(username){
      fetch(`${BaseURLDev}/users/checkuser`, {
         headers,
         method: 'POST',
         body: JSON.stringify({
            "username": username
         })
      })
      .then(response => {
         if (!response.ok) { 
               return Promise.reject(response.statusText);
            }
         return response.json();
      })
      .then(resJSON => {
         return resJSON.status;
      })
      .catch(e => {
         swal("", "Check user error atau sedang terjadi gangguan di server", "error")
      })
   }

   onToggleRadio(){
      this.setState({
         data:{
            ...this.state.data,
            kd_urusan: "",
            kd_bidang: "",
            kd_unit: "",
            kd_sub: "",
         },
         is_manual:!this.state.is_manual
      });
   }

   onChange(e){
      this.updateState([e.target.name],e.target.value);
   }
   updateState = (name,value) => this.setState({data:{...this.state.data, [name]:value}})
   
   opdSelect(){
      if(fetchOPD().length!==0){
         const opds = []
         for(let i=0; i<fetchOPD().length; i++) {
            opds.push({
               'value': fetchOPD()[i].kode_opd,
               'text': `[${fetchOPD()[i].kode_opd}] ${fetchOPD()[i].opd}`,
               'key': i,     
            })
         }
         this.setState({opds:opds})
      }
   }

   getDataOPD(){
      fetch(`${BaseURLDev}/simantra/ref/allopd`)
      .then(response => {
         if(!response.ok){
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         var {skpd,user} = JSON.parse(sessionStorage.data);
         sessionStorage.setItem('data',JSON.stringify({
            user:user,
            opd:resJSON.data,
            skpd:skpd
         }))
         
         const opds = []
         for(let i=0; i<resJSON.data.length; i++) {
            opds.push({
               'value': resJSON.data[i].kode_opd,
               'text': `[${resJSON.data[i].kode_opd}] ${resJSON.data[i].opd}`,
               'key': i,     
            })
         }
         this.setState({opds:opds})
      })
   }
   
   onChangeOPD(e, el){
      const input = el.value;
      const kd_opd = input.split(".").filter(i => i);

      this.setState({
         data: {
            ...this.state.data,
            kd_urusan:kd_opd[0],
            kd_bidang:kd_opd[1],
            kd_unit:kd_opd[2],
            kd_sub:kd_opd[3],
         },
         opd_select_temp: input
      })
   }
   render() {
      const {username,password,nama,jabatan,kode,alamat,contact,kd_urusan,kd_bidang,kd_unit,kd_sub} = this.state.data;
      const {error, loading} = this.state;
      
      return (
         <Grid>         
            <Grid.Column width={8}>
               <Segment color='violet'>
                  <Popup
                     trigger={
                        <Radio toggle style={{marginBottom:'10px'}}
                           onChange={this.onToggleRadio}/> 
                     }
                     header="Toggle OPD"
                     content='Manual input atau memilih list'
                     on='hover'
                     inverted
                  />
                  <Form onSubmit={this.onSubmit} loading={loading}> 
                     
                     {!this.state.is_manual ? 
                        <Grid style={{marginBottom:'5px'}}>
                           <Grid.Column width={4}> 
                              <Form.Input value={kd_urusan}
                                 autoComplete="off"
                                 onChange={(e)=>this.updateState(e.target.name,e.target.value)} 
                                 name="kd_urusan" placeholder="Kode urusan" />
                           </Grid.Column>  
                           <Grid.Column width={4}>  
                                 <Form.Input value={kd_bidang} 
                                 autoComplete="off"
                                 onChange={(e)=>this.updateState(e.target.name,e.target.value)} 
                                 name="kd_bidang" placeholder="Kode bidang"/>
                           </Grid.Column>  
                           <Grid.Column width={4}>  
                              <Form.Input value={kd_unit} 
                                 autoComplete="off"
                                 onChange={(e)=>this.updateState(e.target.name,e.target.value)} 
                                 name="kd_unit" placeholder="Kode unit"/>
                           </Grid.Column>  
                           <Grid.Column width={4}>  
                              <Form.Input value={kd_sub} 
                                 autoComplete="off"
                                 onChange={(e)=>this.updateState(e.target.name,e.target.value)} 
                                 name="kd_sub" placeholder="Kode sub unit"/>
                           </Grid.Column>  
                        </Grid>
                     :
                        <Grid style={{marginBottom:'5px'}}>
                           <Grid.Column width={16}> 
                              <Form.Field 
                                 search
                                 control={Select} 
                                 onChange={this.onChangeOPD} 
                                 options={this.state.opds} 
                                 name="kd_opd" placeholder='Pilih kode OPD' />
                           </Grid.Column>   
                        </Grid>
                     }
                     <Form.Group widths='equal'>
                        <Form.Input autoFocus error={this.state.error_username} value={username} onChange={this.onChange} placeholder="Username" name="username" />
                        {/*error ? <Label horizontal color='red' pointing='left'>That name is taken!</Label>:null*/}
                        <Form.Input error={this.state.error_password} type="password" value={password} onChange={this.onChange} placeholder="Password" name="password" />
                        {/*error ? <Label horizontal color='red' pointing='left'>That name is taken!</Label>:null*/}
                     </Form.Group>

                     <Form.Input error={this.state.error_kode} value={kode} onChange={this.onChange} name="kode" placeholder="NIP/Kode Pegawai"/>
                     <Form.Input error={this.state.error_nama} value={nama} onChange={this.onChange} name="nama" placeholder='Nama pegawai' />               
                     <Form.Input error={this.state.error_jabatan} value={jabatan} onChange={this.onChange} name="jabatan" placeholder='Jabatan pegawai' />               
                     <Form.Input error={this.state.error_contact} value={contact} onChange={this.onChange} name="contact" placeholder='Nomor contact' />               
                     <Form.TextArea error_username={this.state.error_alamat} value={alamat} onChange={this.onChange} placeholder='Alamat pegawai' name="alamat" />
                     <Form.Button positive>Submit</Form.Button>
                  </Form>
               </Segment>
               </Grid.Column>
         </Grid>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_user/_useropd/FormAddOPD.js